var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export var SKPathIcon = function (props) {
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 379 368" }),
        React.createElement("path", { d: "M247 513.501C169.295 458.24 178.186 330.082 239.5 282.5C300.815 234.918 423.849 269.462 450.867 282.5C471.029 292.229 498.092 62.6788 390.475 59.0499C282.858 55.421 285.367 449.69 364.373 397.32C443.378 344.95 334.806 202.195 263 232.501C191.194 262.806 247.477 513.015 298.181 476.969C410.219 397.32 83.7335 254.628 26.9996 355.5C-1.75736 406.63 91.0667 458.637 139.401 460.865", stroke: "#00FF84", strokeWidth: "5", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" })));
};
//# sourceMappingURL=SKPathIcon.js.map